import {Component} from '@angular/core';
import {ProductionSchedule} from '@domain/production-schedule/production-schedule';
import {ProductionScheduleOrderLine} from '@domain/production-schedule/production-schedule-order-line';
import {TagColor} from '@vdw/angular-component-library';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {isNil} from 'lodash-es';
import {ProductionScheduleItemInPathGroupStatusCellRendererParams} from './production-schedule-item-in-path-group-status-cell-renderer-params.interface';

@Component({
  templateUrl: './production-schedule-item-in-path-group-status-cell-renderer.component.html'
})
export class ProductionScheduleItemInPathGroupStatusCellRendererComponent implements ICellRendererAngularComp {
  public pathNumber: number;
  private productionScheduleOrderLine: ProductionScheduleOrderLine;
  private productionSchedule: ProductionSchedule;

  public agInit(params: ProductionScheduleItemInPathGroupStatusCellRendererParams): void {
    this.pathNumber = params?.data?.productionSchedulePath?.pathNumber;
    this.productionScheduleOrderLine = params?.data?.productionScheduleOrderLine;
    this.productionSchedule = params.productionSchedule;
  }

  public refresh(params: ProductionScheduleItemInPathGroupStatusCellRendererParams): boolean {
    return false;
  }

  public getColor(): TagColor {
    const leftForProductionSchedule = this.productionScheduleOrderLine.article.design.repeated
      ? this.productionScheduleOrderLine.getHeightLeftInMMForProductionSchedule(this.productionSchedule.getProductionScheduleItemMultiplier())
      : this.productionScheduleOrderLine.getAmountLeftForProductionSchedule(this.productionSchedule.getProductionScheduleItemMultiplier());

    return isNil(leftForProductionSchedule) || leftForProductionSchedule > 0 ? TagColor.WARNING : TagColor.SUCCESS;
  }
}
